import {createApp} from 'vue'
import CardMediumPI from './CardMediumPI'
import handleComponentProps from '../../../../Frontend/src/foundation/js/utils/handleComponentProps'

const el = '.nyk-component--card-medium-pi'

export default function(Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((CardMediumPIDOM) => {
            const props = handleComponentProps(CardMediumPI, CardMediumPIDOM)
            const component = createApp(CardMediumPI, props).use(Store)
            component.mount(CardMediumPIDOM)
        })
    }
}